"use client";
import { useEffect, useState } from "react";
import CountrySelectionPopup from "../CountrySelectionPopup";

const APP_VERSION = "2.0.5"; // bump this when you want to clear again
const isProduction = process.env.NODE_ENV === "production";

export default function BrowserDataResetWrapper() {
    // const [ready, setReady] = useState(false);

    useEffect(() => {
        const lastVersion = localStorage.getItem("app_version");
        if (lastVersion !== APP_VERSION) {
            try {
                localStorage.clear();
                sessionStorage.clear();
                localStorage.setItem("app_version", APP_VERSION);
                // Clear cookies
                document.cookie.split(";")?.forEach((cookie) => {
                    const eqPos = cookie?.indexOf("=");
                    const name =
                        eqPos > -1
                            ? cookie?.substring(0, eqPos)?.trim()
                            : cookie?.trim();
                    if (name === "countryCode") return;
                    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
                });
                location.reload();
                // localStorage.removeItem('country-store');
            } catch (err) {
                console.error("Error clearing storage:", err);
            }
        }

        // setReady(true);
    }, []);

    return null;

    // if (!ready) return null;

    // return (
    //   <>
    //     <CountrySelectionPopup />
    //   </>
    // );
}
